export class DisclosureInfo {
    public readDisclosure:boolean;
    public title:string;
    public text:string;
}